var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top10-device-bar-chart"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('she_bei_bang_dan'))+" Top10")]),_c('div',{staticClass:"chart",attrs:{"id":"top10DeviceBarChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }